import React from 'react';
import PropTypes from 'prop-types';

// PrimeReact UI components
import {Checkbox} from 'primereact/checkbox';
import {ResolutionList} from '../catalog/catalog-constants';

// Styles
import 'primereact/resources/themes/nova-light/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';

const resolutionPicker = ({criteriaId, resolution, onChange, updateResolutionList}) => {
    const options = new Array();

    if (!resolution) {
        updateResolutionList(criteriaId);
    }

    for (let i = 0; i < ResolutionList.length; i++) {
        let checked = false;

        if (resolution) {
            const enumValue = ResolutionList[i].searchValue;

            for (let r = 0; r < resolution.length; r++) {
                if (enumValue == resolution[r].resId) {
                    checked = resolution[r].selected;
                    break;
                }
            }
        }

        options.push(
            <div className="p-col-12">
                <Checkbox
                    checked={checked}
                    id={`res${criteriaId}_${ResolutionList[i].searchValue}`}
                    inputId={`res${criteriaId}_${ResolutionList[i].searchValue}`}
                    onChange={onChange}
                />
                <label className="p-checkbox-label" htmlFor={`res${criteriaId}_${ResolutionList[i].resolutionName}`}>
                    {ResolutionList[i].resolutionName}
                </label>
            </div>
        );
    }

    return (
        <div className="p-grid">
            {' '}
            <div className="p-col">{options}</div>
        </div>
    );
};

resolutionPicker.propTypes = {
    criteriaId: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    resolution: PropTypes.array,
    updateResolutionList: PropTypes.func.isRequired,
};

export default resolutionPicker;
